// @flow

class VHVars {
    constructor() {
        this.setVHUnits();
        this.attachHandlers();
    }

    setVHUnits = () => {
        const vh = window.innerHeight;
        if (document.body) {
            document.body.style.setProperty("--vh", `${vh}px`);
        }
    };

    attachHandlers = () => {
        window.addEventListener("resize", this.setVHUnits);
    };
}

new VHVars();
